<template lang="pug">
div.multi-layer-section
    div.category-tree.content
        input.form-control(type='text', v-model.lazy='keyword', name='keyword', placeholder='Search tag...', style='margin-bottom: 16px;')
        v-jstree(
            ref="categoryTree"
            :data="treeData"
            :loading-text="`Fetching...`"
            :item-events="itemEvents"
            no-dots
            :collapse="true"
            @item-click="categoryClick")
    div.border-multilayer#border-multilayer
    div.product-section
        div(v-if="selectedCategory")
            div.section-action
                div
                    span.title-section Tags Details
                    Breadcrumb(:ancestors="ancestors")
                    span.title {{ this.selectedCategory.text }}
                div 
                    button.btn.btn-action(@click="createProduct") Create Product
                    button.btn.btn-action(@click="editCategory" style="margin-left: 10px") Assign Product
            hr.border-product-action
            div.product-list
                <vuetable_item :isRequiredCategoryFilter="false" :isRequiredTagFilter="false" :tagSelected="this.selectedCategory.id" :isForMultiLayerCategory="true">
                </vuetable_item>
        EmptyState(v-else)
            template(slot="image")
                svg(width='250' height='200' viewbox='0 0 250 200' fill='none' xmlns='http://www.w3.org/2000/svg')
                    rect(width='250' height='200' fill='white')
                    path(fill-rule='evenodd' clip-rule='evenodd' d='M63 134H154C154.515 134 155.017 133.944 155.5 133.839C155.983 133.944 156.485 134 157 134H209C212.866 134 216 130.866 216 127C216 123.134 212.866 120 209 120H203C199.134 120 196 116.866 196 113C196 109.134 199.134 106 203 106H222C225.866 106 229 102.866 229 99C229 95.134 225.866 92 222 92H200C203.866 92 207 88.866 207 85C207 81.134 203.866 78 200 78H136C139.866 78 143 74.866 143 71C143 67.134 139.866 64 136 64H79C75.134 64 72 67.134 72 71C72 74.866 75.134 78 79 78H39C35.134 78 32 81.134 32 85C32 88.866 35.134 92 39 92H64C67.866 92 71 95.134 71 99C71 102.866 67.866 106 64 106H24C20.134 106 17 109.134 17 113C17 116.866 20.134 120 24 120H63C59.134 120 56 123.134 56 127C56 130.866 59.134 134 63 134ZM226 134C229.866 134 233 130.866 233 127C233 123.134 229.866 120 226 120C222.134 120 219 123.134 219 127C219 130.866 222.134 134 226 134Z' fill='#F3F7FF')
                    path(fill-rule='evenodd' clip-rule='evenodd' d='M113.119 112.307C113.04 112.86 113 113.425 113 114C113 120.627 118.373 126 125 126C131.627 126 137 120.627 137 114C137 113.425 136.96 112.86 136.881 112.307H166V139C166 140.657 164.657 142 163 142H87C85.3431 142 84 140.657 84 139V112.307H113.119Z' fill='white')
                    path(fill-rule='evenodd' clip-rule='evenodd' d='M138 112C138 119.18 132.18 125 125 125C117.82 125 112 119.18 112 112C112 111.767 112.006 111.536 112.018 111.307H84L93.5604 83.0389C93.9726 81.8202 95.1159 81 96.4023 81H153.598C154.884 81 156.027 81.8202 156.44 83.0389L166 111.307H137.982C137.994 111.536 138 111.767 138 112Z' fill='white')
                    path(fill-rule='evenodd' clip-rule='evenodd' d='M136.098 112.955C136.098 118.502 131.129 124 125 124C118.871 124 113.902 118.502 113.902 112.955C113.902 112.775 113.908 111.596 113.918 111.419H93L101.161 91.5755C101.513 90.6338 102.489 90 103.587 90H146.413C147.511 90 148.487 90.6338 148.839 91.5755L157 111.419H136.082C136.092 111.596 136.098 112.775 136.098 112.955Z' fill='#E8F0FE')
                    path(fill-rule='evenodd' clip-rule='evenodd' d='M85.25 111.512V138C85.25 138.966 86.0335 139.75 87 139.75H163C163.966 139.75 164.75 138.966 164.75 138V111.512L155.255 83.4393C155.015 82.7285 154.348 82.25 153.598 82.25H96.4023C95.6519 82.25 94.985 82.7285 94.7446 83.4393L85.25 111.512Z' stroke='#1F64E7' stroke-width='2.5')
                    path(d='M98 111C101.937 111 106.185 111 110.745 111C112.621 111 112.621 112.319 112.621 113C112.621 119.627 118.117 125 124.897 125C131.677 125 137.173 119.627 137.173 113C137.173 112.319 137.173 111 139.05 111H164M90.5737 111H93H90.5737Z' stroke='#1F64E7' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round')
                    path(d='M150.1 58.3027L139 70.7559M124.1 54V70.7559V54ZM98 58.3027L109.1 70.7559L98 58.3027Z' stroke='#75A4FE' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round')
            template(slot="heading")
                | No product list to display
            template(slot="sub-heading")
                | Try to find the product by selecting the category
    
    ManageTag
    CategoryMenu
</template>


<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import store from '../../../store/modules/tag';
import CategoryMenu from './category-menu.vue';
import ManageTag from './manage-tag.vue';
import EmptyState from './../../../components/EmptyState.vue';
import Breadcrumb from './components/breadcrumb.vue';

const debouncedItemToggle = _.debounce(async (node, resolve) => {
    let response = await store.actions.getTagTree(_, node.data.id);
    resolve(response.data);
}, 250);

export default {
    components: {
        CategoryMenu,
        ManageTag,
        EmptyState,
        Breadcrumb,
    },

    data() {
        return {
            itemEvents: {
                contextmenu: function() {
                    let [vueInstance, model, event] = arguments;
                    let bound = vueInstance.$el.getBoundingClientRect();
                    event.preventDefault();
                    vueInstance.$bus.$emit('category_menu::toggle-menu', {
                        event,
                        model,
                        bound,
                    });
                    vueInstance.selectedCategory = model;
                },
            },
            selectedCategory: null,
            keyword: null,
            ancestors: [],
            // treeData: [],
            // loadTreeData: async function(node, resolve) {
            //     if (!this.$store.state.tag.firstLoad) {
            //         debouncedItemToggle(node, resolve);
            //     } else {
            //         setTimeout(() => {
            //             resolve(this.$store.state.tag.treeTag);
            //         }, 500);
            //     }
            // },
        };
    },

    computed: {
        treeData() {
            return this.$store.state.tag.treeTag;
        },
    },

    watch: {
        keyword: {
            handler: async function(keyword, oldVal) {
                await this.$store.dispatch(`tag/getTagTree`, { keyword });
            },
            deep: true,
        },
    },

    async created() {
        await this.getTagTree();
        this.registerEvent();
    },

    mounted() {
        let handler = document.querySelector('.border-multilayer');
        let wrapper = handler.closest('.multi-layer-section');
        let boxA = wrapper.querySelector('.category-tree');

        this.mouseMoveWhilstDown(handler, function(event) {
            let containerOffsetLeft = wrapper.offsetLeft;

            let pointerRelativeXpos = event.clientX - containerOffsetLeft;
            let boxAminWidth = 100;

            boxA.style.width =
                Math.max(boxAminWidth, pointerRelativeXpos - 8) + 'px';
            boxA.style.flexGrow = 0;
        });
    },

    beforeDestroy() {
        this.$off('category_tree::rebuild');
    },

    methods: {
        ...mapActions('tag', ['getTagTree']),

        mouseMoveWhilstDown(target, whileMove) {
            var endMove = function() {
                window.removeEventListener('mousemove', whileMove);
                window.removeEventListener('mouseup', endMove);
            };

            target.addEventListener('mousedown', function(event) {
                event.stopPropagation();
                window.addEventListener('mousemove', whileMove);
                window.addEventListener('mouseup', endMove);
            });
        },

        categoryClick(node) {
            this.selectedCategory = node.model;
            this.ancestors = node.model.ancestor;
        },

        editCategory() {
            this.$bus.$emit('manage_tag::show_form', this.selectedCategory);
        },

        registerEvent() {
            this.$bus.$on('category_tree::rebuild', data => {
                this.refreshNode();
            });
        },

        async refreshNode() {
            await this.getTagTree();
            // this.$store.state.tag.treeData = [this.$refs.categoryTree.initializeLoading()];
            // this.$refs.categoryTree.handleAsyncLoad(
            //     this.treeData,
            //     this.$refs.categoryTree,
            // );
        },

        createProduct() {
            this.$bus.$emit('table_item::show_create_form');
        },
    },
};
</script>

<style lang="scss" scoped>
.multi-layer-section {
    background-color: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    .content {
        padding: 1rem;
    }

    .category-tree {
        flex: 0 auto;
        min-width: 200px;
        max-width: 250px;
        overflow-x: hidden;
        max-height: 80vh;
    }
    .product-section {
        margin: 0;
        padding: 0;
        flex: 1 auto;
        display: flex;
        flex-direction: column;

        .section-action {
            margin-top: 0.4rem;
            margin-bottom: 0.4rem;
            padding-left: 1rem;
            padding-right: 1rem;
            padding-top: 0.5rem;
            padding-bottom: 0.5rem;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;

            .title-section {
                font-size: 12px;
                color: rgb(176, 176, 176);
            }
            .title {
                font-size: 20px;
                font-weight: 500;
            }
            .btn-action {
                background-color: #309cff;
                border-radius: 10px;
                color: #fff;
            }
        }
        .border-product-action {
            margin-top: 0;
            margin-bottom: 0;
            border: 4px;
            border-top: 4px solid rgba(240, 240, 240, 1);
        }
    }
}

.border-multilayer {
    padding: 0;
    cursor: ew-resize;
    flex: 0 0 auto;
}

.border-multilayer::before {
    content: '';
    display: block;
    width: 4px;
    height: 100%;
    background: #f0f0f0;
    margin: 0 auto;
}

.section-category-menu {
    position: relative;
}

.context-menu {
    background-color: #fff;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 100000;
}
</style>

<style lang="scss">
.icon-tree-blue {
    color: #6da7ff;
    font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/tag/multi_layer_section.vue